import { Link } from "react-router-dom";
import { BRAND } from "../lib/brand";
import { useState, useEffect } from "react";
import { useContent } from "../context/ContentContext";

export default function Nav({ onJoinClick }) {
    const { content } = useContent();
    const logo = content.brand?.logo || BRAND.logo;
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 30);
        onScroll();
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const links = [
        { label: "About", href: "#about" },
        { label: "How We Work", href: "#how" },
        { label: "Gallery", href: "#gallery" },
        { label: "Leaders", href: "#leaders" },
        { label: "Merch", href: "#merch" },
        { label: "Stats", href: "#stats" },
    ];

    return (
        <nav
            data-testid="main-nav"
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
                scrolled ? "bg-black/85 backdrop-blur-xl border-b border-meraki-gold/20" : "bg-transparent"
            }`}
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-4 flex items-center justify-between">
                <a href="#top" className="flex items-center gap-3" data-testid="nav-logo">
                    <img src={logo} alt="Meraki Riders Logo" className="h-12 w-12 object-contain" />
                    <div className="hidden sm:block">
                        <div className="font-display text-meraki-gold text-xl leading-none tracking-wide">MERAKI</div>
                        <div className="text-[10px] uppercase tracking-[0.3em] text-meraki-muted leading-none mt-1">Riders Group</div>
                    </div>
                </a>

                <div className="hidden lg:flex items-center gap-10">
                    {links.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                            className="text-xs uppercase tracking-[0.25em] text-meraki-text/80 hover:text-meraki-gold transition-colors gold-underline"
                        >
                            {l.label}
                        </a>
                    ))}
                </div>

                <div className="flex items-center gap-3">
                    <Link
                        to="/admin/login"
                        data-testid="nav-admin-link"
                        className="hidden md:block text-xs uppercase tracking-[0.2em] text-meraki-muted hover:text-meraki-gold transition-colors"
                    >
                        Admin
                    </Link>
                    <button
                        data-testid="nav-join-btn"
                        onClick={onJoinClick}
                        className="px-5 py-3 bg-meraki-gold text-black text-xs uppercase tracking-[0.2em] font-semibold hover:bg-meraki-gold-hover transition-colors"
                    >
                        Join Us
                    </button>
                    <button
                        onClick={() => setOpen((v) => !v)}
                        className="lg:hidden text-meraki-gold p-2"
                        aria-label="Menu"
                        data-testid="nav-mobile-toggle"
                    >
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M3 6h18M3 12h18M3 18h18" />
                        </svg>
                    </button>
                </div>
            </div>

            {open && (
                <div className="lg:hidden bg-black border-t border-meraki-gold/20 px-6 py-6 flex flex-col gap-4">
                    {links.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            onClick={() => setOpen(false)}
                            className="text-sm uppercase tracking-[0.25em] text-meraki-text"
                        >
                            {l.label}
                        </a>
                    ))}
                    <Link to="/admin/login" className="text-sm uppercase tracking-[0.25em] text-meraki-muted">Admin</Link>
                </div>
            )}
        </nav>
    );
}
